const LOCALES = Object.freeze({
  EN: 'en-US',
  IT: 'it-IT',
});

const COUNTRY_CODES = Object.freeze({
  [LOCALES.EN]: 'US',
  [LOCALES.IT]: 'IT',
});

const LABELS = Object.freeze({
  [LOCALES.EN]: 'English',
  [LOCALES.IT]: 'Italiano',
});

const SHORT_LABELS = Object.freeze({
  [LOCALES.EN]: 'en',
  [LOCALES.IT]: 'it',
});

const STORAGE_KEY = 'ekyc-locale';

export default Object.freeze({
  COUNTRY_CODES,
  LABELS,
  LOCALES,
  SHORT_LABELS,
  STORAGE_KEY,
});
